import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "82",
  height: "90",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      stroke: "#F2647A",
      "stroke-width": "2",
      d: "M81 83.25v-77a5 5 0 0 0-5-5H23.657a5 5 0 0 0-3.536 1.464l-8.828 8.829-8.829 8.828A5 5 0 0 0 1 23.907V83.25a5 5 0 0 0 5 5h70a5 5 0 0 0 5-5Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#F2647A",
      d: "m22 2.25-20 20h16a4 4 0 0 0 4-4z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#F2647A",
      "stroke-width": "2",
      d: "m16 18 64 69m0-84L2 87"
    }, null, -1)
  ])))
}
export default { render: render }